import axios from "axios";
import { Url, Url2 } from "../API/API.jsx";

export const CheckLogin = async (data) => {
  const config = {
    headers: {
      Authorization: "Basic bW9iaWxlQXBpVXNlcjpQN2ZzVXg3dFBxTEE1eUx2SnpvWg==",
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.post(`${Url}/login/check`, data, config);
};

export const RequestOTP = async (data) => {
  const config = {
    headers: {
      Authorization: "Basic bW9iaWxlQXBpVXNlcjpQN2ZzVXg3dFBxTEE1eUx2SnpvWg==",
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.post(`${Url}/otp/request`, data, config);
};

export const checkOTP = async (data) => {
  const config = {
    headers: {
      Authorization: "Basic bW9iaWxlQXBpVXNlcjpQN2ZzVXg3dFBxTEE1eUx2SnpvWg==",
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.post(`${Url}/otp/check`, data, config);
};

export const RegisterStep1 = async (data) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.post(`${Url}/register`, data, {
    ...config,
    maxRedirects: 0,
    validateStatus: (status) =>
      (status >= 200 && status < 300) || status === 302,
  });
};

export const RegisterStep2 = async (data) => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.post(`${Url}/register/driver`, data, config);
};

export const Provinces = async () => {
  const config = {
    headers: {
      Authorization: `Basic bW9iaWxlQXBpVXNlcjpQN2ZzVXg3dFBxTEE1eUx2SnpvWg==`,
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.get(`${Url2}/user/provinces`, config);
};

export const Cities = async (id) => {
  const config = {
    headers: {
      Authorization: `Basic bW9iaWxlQXBpVXNlcjpQN2ZzVXg3dFBxTEE1eUx2SnpvWg==`,
      Accept: "*/*",
      "Content-Type": "application/json",
    },
  };

  return await axios.get(`${Url2}/user/cities?province=${id}`, config);
};

// export const Token = async (data) => {
//   const config = {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem("token")}`,
//       Accept: "*/*",
//       "Content-Type": "application/json",
//     },
//   };
//   return await axios.post(`${Url}/login/token`, data, config);
// };
